import {
  GetIvsClientIdFunction,
  GetLoginIvsEventTypeFunction,
} from '@shopee-user/business-customization-types';

const IVS_CLIENT_ID = 11;

export const getIvsClientId: GetIvsClientIdFunction = () => {
  return IVS_CLIENT_ID;
};

export const getLoginIvsEventType: GetLoginIvsEventTypeFunction = () => {
  return -1;
};
